export class JiraTicket {
  key: string;
  summary: string;
  status: string;
  workType: string;
  url?: string;
  customFields: Record<string, any> = {};

  deserialize(input: any): this {
    this.key = input.key;
    this.summary = input.summary;
    this.status = input.status;
    this.workType = input.issueType;
    this.url = input.url ?? undefined;
    this.customFields = input.customFields ?? {};
    return this;
  }
}
